import React, { useEffect, useRef } from "react";
import { Routes, Route, NavLink } from "react-router-dom";
import Analysis from "./Analysis";
import ProfitLoss from "./ProfitLoss";
import BalanceSheet from "./BalanceSheet";
import CashFlow from "./CashFlow";
import Ratios from "./Ratios";
import Investors from "./Investors";
import style from "../../../css/dashboard/fundamental/StockDetails.module.css";
import Fundamental from "./Fundamental";
import StockChart from "./Chart";

const StockDetails = ({ selectedCompany }) => {


const isDisabled = !selectedCompany || !selectedCompany.scripname?.trim();


const collapseRef = useRef();

useEffect(() => {
    const collapseElement = collapseRef.current;
    const navLinks = collapseElement.querySelectorAll(".nav-link");

    const handleLinkClick = () => {
        const bsCollapse = window.bootstrap?.Collapse;
        if (bsCollapse) {
            const collapseInstance = bsCollapse.getInstance(collapseElement);
            collapseInstance?.hide(); // Collapse the navbar
        }
    };

    navLinks.forEach((link) => link.addEventListener("click", handleLinkClick));

    // Optional: Close on outside click
    const handleOutsideClick = (e) => {
        if (!collapseElement.contains(e.target)) {
            const collapseInstance = window.bootstrap?.Collapse.getInstance(collapseElement);
            collapseInstance?.hide();
        }
    };
    document.addEventListener("click", handleOutsideClick);

    return () => {
        navLinks.forEach((link) => link.removeEventListener("click", handleLinkClick));
        document.removeEventListener("click", handleOutsideClick);
    };
}, []);




    return (
        <div className={style.container}>
            <nav className={`navbar navbar-expand-xl ${style.navbarWrapper}`}>
                <div className="container-fluid">
                    <button
                    className={`navbar-toggler ${style.navbartoggle}`}
                      
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#stockNavbar"
                        aria-controls="stockNavbar"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                      <i className="fa-solid fa-bars"></i>
                    </button>

                    <div className={`collapse navbar-collapse ${style.collapse_subbar}`}   ref={collapseRef} id="stockNavbar">
                        <ul className={`navbar-nav ${style.navList}`}>
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/companymaster"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                >
                                    {selectedCompany?.scripname?.trim() || "Company"}
                                </NavLink>
                            </li>
                            {/* <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/chart"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                    onClick={(e) => isDisabled && e.preventDefault()}
                                >
                                    Chart
                                </NavLink>
                            </li> */}
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/analysis"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                    onClick={(e) => isDisabled && e.preventDefault()}
                                >
                                    Analysis
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/profit-loss"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                    onClick={(e) => isDisabled && e.preventDefault()}
                                >
                                    Profit & Loss
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/balance-sheet"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                    onClick={(e) => isDisabled && e.preventDefault()}
                                >
                                    Balance Sheet
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/cash-flow"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                    onClick={(e) => isDisabled && e.preventDefault()}
                                >
                                    Cash Flow
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/ratios"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                    onClick={(e) => isDisabled && e.preventDefault()}
                                >
                                    Ratios
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/dashboard/fundamental/investors"
                                    className={({ isActive }) =>
                                        `nav-link ${isActive ? style.active : ""} ${isDisabled ? style.disabled : ""}`
                                    }
                                    onClick={(e) => isDisabled && e.preventDefault()}
                                >
                                    Investors
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div className={style.content}>
                <Routes>
                    <Route index element={<Fundamental selectedCompany={selectedCompany} />} />
                    <Route path="companymaster" element={<Fundamental selectedCompany={selectedCompany} />} />
                    <Route path="chart" element={<StockChart selectedCompany={selectedCompany} />} />
                    <Route path="analysis" element={<Analysis selectedCompany={selectedCompany} />} />
                    <Route path="profit-loss" element={<ProfitLoss selectedCompany={selectedCompany} />} />
                    <Route path="balance-sheet" element={<BalanceSheet selectedCompany={selectedCompany} />} />
                    <Route path="cash-flow" element={<CashFlow selectedCompany={selectedCompany} />} />
                    <Route path="ratios" element={<Ratios selectedCompany={selectedCompany} />} />
                    <Route path="investors" element={<Investors selectedCompany={selectedCompany} />} />
                </Routes>
            </div>
        </div>
    );
};

export default StockDetails;
